// Stellarium Web - Copyright (c) 2022 - Stellarium Labs SRL
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div id="toolbar-image">
    <v-toolbar class="transparent" dense>
      <v-app-bar-nav-icon @click="toggleNavigationDrawer"></v-app-bar-nav-icon>
      <img class="tbtitle hidden-xs-only" id="stellarium-web-toolbar-logo" src="@/assets/images/logo.svg" width="30" height="30" alt="Stellarium Web Logo"/>
      <span class="tbtitle hidden-sm-and-down">Stellarium<sup>Web</sup></span>
      <v-spacer></v-spacer>
      <target-search></target-search>
      <v-spacer></v-spacer>
      <div v-if="$store.state.showFPS" class="subheader grey--text hidden-sm-and-down pr-2" style="user-select: none;">FPS {{ $store.state.stel ? $store.state.stel.fps.toFixed(1) : '?' }}</div>
      <div class="subheader grey--text hidden-sm-and-down" style="user-select: none;">FOV {{ fov }}</div>
      <v-btn class="transparent hidden-sm-and-up" @click="toggleDeviceOrientation" :style="$store.state.useDeviceOrientation ? 'color: #62d1df' : ''">
        <v-icon>{{ $store.state.useDeviceOrientation ? 'mdi-crosshairs-gps' : 'mdi-navigation' }}</v-icon>
        <span class="ml-1 hidden-xs-only" style="font-size: 11px">{{ $t('Follow device orientation') }}</span>
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>

import TargetSearch from '@/components/target-search'

export default {
  data: function () {
    return {
    }
  },
  computed: {
    fov: function () {
      if (!this.$store.state.stel) return '-'
      const fov = this.$store.state.stel.fov * 180 / Math.PI
      return fov.toPrecision(3) + '°'
    }
  },
  methods: {
    toggleNavigationDrawer: function () {
      this.$store.commit('toggleBool', 'showNavigationDrawer')
    },
    toggleDeviceOrientation: function () {
      const enable = !this.$store.state.useDeviceOrientation
      this.$store.commit('setValue', { varName: 'useDeviceOrientation', newValue: enable })
      if (enable) {
        this.startDeviceOrientation()
      } else {
        this.stopDeviceOrientation()
      }
    },
    startDeviceOrientation: function () {
      const that = this
      this._deviceOrientationHandler = function (event) {
        if (!that.$store.state.stel) return
        const alpha = event.alpha
        const beta = event.beta
        if (alpha === null || beta === null) return
        const D2R = Math.PI / 180
        const yaw = -alpha * D2R
        const pitch = (beta - 90) * D2R
        try {
          that.$store.state.stel.core.observer.yaw = yaw
          that.$store.state.stel.core.observer.pitch = -pitch
        } catch (e) {}
      }
      window.addEventListener('deviceorientation', this._deviceOrientationHandler)
      // Contournement iOS : les events deviceorientation ne sont pas
      // dispatchés dans les iframes sur iOS Safari. Le parent forward les
      // valeurs via postMessage ; on les rejoue ici dans le handler.
      this._deviceOrientationMessageHandler = function (event) {
        if (!event.data || event.data.type !== 'tracker1-device-orientation') return
        that._deviceOrientationHandler({
          alpha: event.data.alpha,
          beta: event.data.beta,
          gamma: event.data.gamma
        })
      }
      window.addEventListener('message', this._deviceOrientationMessageHandler)
      if (typeof DeviceOrientationEvent !== 'undefined' && DeviceOrientationEvent.requestPermission) {
        DeviceOrientationEvent.requestPermission().catch(function () {})
      }
    },
    stopDeviceOrientation: function () {
      if (this._deviceOrientationHandler) {
        window.removeEventListener('deviceorientation', this._deviceOrientationHandler)
        this._deviceOrientationHandler = null
      }
      if (this._deviceOrientationMessageHandler) {
        window.removeEventListener('message', this._deviceOrientationMessageHandler)
        this._deviceOrientationMessageHandler = null
      }
    }
  },
  components: { TargetSearch }
}
</script>

<style>
#toolbar-image {
  background: url("../assets/images/header.png") center;
  background-position-x: 55px;
  background-position-y: 0px;
  height: 48px;
  z-index: 1;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
}

#stellarium-web-toolbar-logo {
  margin-right: 10px;
  margin-left: 30px;
}

.tbtitle {
  font-size: 20px;
  font-weight: 500;
  user-select: none;
}
</style>
